<template>
<v-card>

  <v-hover>
    <template v-slot:default="{ hover }">
      <router-link class="nolink" :to="project.status=== 11 ? `/project/${project.id}/${project.slug}` : `/user/projects/${project.id}`">
    <v-img :aspect-ratio="16/9" :src="project.thumbnail_large">
      <v-row class="lightbox white--text pa-2 fill-height">
        <v-fade-transition>
          <v-overlay :absolute="true" :value="true" :opacity="0.6" v-if="hover">
            <v-btn color="primary" >
              <v-icon small>fa-play</v-icon>
            </v-btn>
          </v-overlay>
        </v-fade-transition>
      </v-row>
    </v-img>
  </router-link>
  </template>
  </v-hover>
  <v-card-title class="secondary white--text" v-if="project.report">
    <h5>Quality card</h5>
    <v-spacer></v-spacer>
    <v-btn dark icon @click="show_more = !show_more">
      <v-icon v-if="!show_more">fa-chevron-down</v-icon>
      <v-icon v-if="show_more">fa-minus</v-icon>
    </v-btn>
  </v-card-title>
  <v-expand-transition>
    <v-simple-table v-if="show_more">
      <template v-slot:default>
  <thead>
  <tr>
  <th class="text-left clicky">
    <v-btn text color="secondary" v-if="project.report.congrats_video"  @click="$eventBus.$emit('play_video',project.report.congrats_video)"><v-icon small color="primary" class="mr-2" >fa-play</v-icon>Congrats</v-btn>
  </th>
  <th v-for="n in 10" :key="n" style="min-width:120px" :class="`text-center white--text rank-${n}-bg`">Rank {{n}}</th>
  </tr>
  </thead>
  <tbody>
  <tr v-for="(category,i,k) in project.report.score" :key="k">
  <td class="caption" style="min-width:120px;">
   {{categories[i].label}}
  </td>
  <td v-for="n in 10" :key="n" style="min-width:120px;border-left:1px solid rgba(0, 0, 0, 0.12)" :class="`text-center ${category[n - 1] ? '' : 'secondary lighten-3'}`">


   <div v-if="category[n - 1]">
     <span :class="`rank-star rank-${n}-star`">
       <v-icon small v-if="category[n-1].reduce((c,j)=>c+j, 0) == category[n-1].length">fas fa-star</v-icon>
        <v-icon small v-else>far fa-star</v-icon>
     </span>
     <v-menu open-on-hover top offset-y v-for="(goal,goal_i) in category[n-1]" :key="goal_i">
       <template v-slot:activator="{ on }">
     <v-btn small icon v-on="on" >
       <v-icon small color="green" v-if="goal">far fa-check-square</v-icon>
        <v-icon small color="red" v-if="!goal">far fa-square</v-icon>
     </v-btn>
       </template>
      <v-card>
        <v-card-text>
          <p class="mb-0">
            {{categories[i].goals[n-1][goal_i]}}
          </p>
        </v-card-text>
      </v-card>
      </v-menu>
      </div>

      <div v-else :class="`text-center`">
        <v-tooltip bottom v-if="k==4">
          <template v-slot:activator="{ on }">
          <v-icon v-on="on" x-large dark>fa-lock</v-icon>
          </template>
          <span>This rank is locked</span>
        </v-tooltip>
        <v-icon v-else>fa-blank</v-icon>
      </div>


      </td>


      </tr>
      </tbody>
      <tfoot>
        <tr style="border-top: 1px solid rgba(0, 0, 0, 0.12);">
          <th class="text-left">Total</th>
          <th v-for="n in 10" :key="n" style="min-width:120px" :class="`text-center white--text rank-${n}-bg`">
            <span v-if="project.report.stars[n-1]">{{project.report.stars[n-1]}} / 10</span>
          </th>
        </tr>
      </tfoot>
      </template>
    </v-simple-table>
  </v-expand-transition>
</v-card>
</template>
<script>
export default {
  props: ['project'],
  name: "",
  data: () => ({
    show_more: false
  }),
  computed: {
    categories() {
      return this.$store.state.app.project_report_categories
    }
  }
}
</script>
<style lang="scss" scoped>
.v-data-table__wrapper {
    overflow-x: scroll;
}
@media only screen and (max-width: 768px) {
    /* For mobile phones: */
    .v-data-table__wrapper {
        overflow-x: auto;
    }
}

td {
    border-bottom: 1px solid rgba(0, 0, 0, 0) !important;
}
</style>
